import { Billing } from '@invoice-simple/common';

import Rollbar from 'src/analytics/rollbar';
import UserModel from 'src/models/UserModel';
import { API_V3_BASE_PATH, client } from './httpClient';

export type Address = {
  street?: string;
  city?: string;
  state: string;
  country: string;
  country_code?: string;
  zip_code?: string;
};

export const createBillingAddress = async (address: Address & { source: string }) => {
  try {
    const user = UserModel.getInstance();
    const { baseURL, headers } = user.getApiV3ReqOpts();
    const path = baseURL + API_V3_BASE_PATH + '/billing';
    const response = await client.post<Billing>(path, address, { headers });
    return response.data;
  } catch (error) {
    Rollbar.trackError('Error saving billing address', error);
    return null;
  }
};

export const getBillingAddress = async (): Promise<Address | null> => {
  try {
    const user = UserModel.getInstance();
    const { baseURL, headers } = user.getApiV3ReqOpts();
    const path = baseURL + API_V3_BASE_PATH + '/billing';
    const response = await client.get<Billing>(path, { headers });
    return response.data;
  } catch (error) {
    Rollbar.trackError('Error getting billing address', error);
    return null;
  }
};
